(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .controller('EventDisplayController', EventDisplayController);

    EventDisplayController.$inject = ['$state', '$stateParams', 'common', 'dataservice', '$interval', '$timeout', '$sce' ];

    function EventDisplayController($state, $stateParams, common, dataservice, $interval, $timeout, $sce) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.title = "Event Display";
        vm.currentDate = new Date();
        vm.promos = [];
        vm.logo = {};
        vm.PictureBackgroundImage = {};
        vm.MainBackgroundImage = {};
        vm.onPage = 0;
        vm.onPromoImageIndex = 0;
        vm.totalNumberOfPages = 0;
        vm.bookings = [];
        vm.firstTime = true;
        vm.bookingPager;
        vm.showingPromos = false;
        vm.isLicenseValid = false;
        vm.isLoading = true;
        vm.inUseText = inUseText;
        vm.roomInUse = false;
        vm.checkIsCurrentBooking = checkIsCurrentBooking;
        vm.opsIncludeVersion = common.opsIncludeVersion;

        vm.isPictureBox = isPictureBox;
        vm.mainboxStyle = mainboxStyle;
        vm.pictureBoxStyle = pictureBoxStyle;
        vm.getPictureBoxContent = getPictureBoxContent;
        vm.currentBooking = {};
        vm.roomName = roomName;
        vm.roomCode = "";
        vm.roomDescription = "";
        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                $interval(timerTick, 1000);
                common.notifier.notify(common.config.events.stateChanged);
                getBookings();
                vm.isLoading = false;
            }, function (error) { });
        }

        function timerTick() {
            vm.currentDate = new Date();
            if (vm.currentDate.getSeconds() == 0) {
                checkInUse();
            }
        }

        function isPictureBox() {
            if (vm.item) {
                return vm.item.DisplayTypeUId === common.config.displayTypes.pictureBox;
            }
            return false;
        }

        function roomName() {
            return vm.currentBooking.Room || vm.roomDescription;
        }

        function checkIsCurrentBooking(b) {
            if (vm.item) {
                if (vm.item.DisplayTypeUId == common.config.displayTypes.roomCard) { 
                    var now = moment.utc();
                    
                    if (b.StatusTypeId === -14) {
                        var bStart = moment.utc(b.EventStartUtc);
                        var bEnd = moment.utc(b.EventEndUtc);
                        if (now.isBetween(bStart, bEnd)) {
                            return true;
                        }
                    }
                        
                }
            }
            return false;
        }

        function checkInUse() {
            var now = moment.utc();
            if (vm.item) {
                if (vm.allBookings) {
                    if (vm.item.DisplayTypeUId === common.config.displayTypes.roomCard
                        || vm.item.DisplayTypeUId === common.config.displayTypes.pictureBox) {

                        var startProperty = "EventStartUtc";
                        var endProperty = "EventEndUtc";

                        if (vm.item.DisplayTypeUId === common.config.displayTypes.pictureBox) {
                            if (vm.item.InProgressStartOnReservedTime) {
                                startProperty = "ReservedStartUtc";
                            }
                            if (vm.item.InProgressEndOnReservedTime) {
                                endProperty = "ReservedEndUtc";
                            }
                        }

                        for (var i = 0; i < vm.allBookings.length; i++) {
                            var b = vm.allBookings[i];
                            if (b.StatusTypeId === -14) {
                                var bStart = moment.utc(b[startProperty]);
                                var bEnd = moment.utc(b[endProperty]);
                                if (now.isBetween(bStart, bEnd)) {
                                    vm.currentBooking = b;
                                    vm.roomInUse = true;
                                    setCrestronInUse();
                                    return;
                                }
                            }

                        }
                    }
                }
            }
            vm.currentBooking = {};
            vm.roomInUse = false;
            setCrestronVacant();
        }

        function setCrestronVacant() {
            try {
                Crestron.sendBooleanSignal("USB_RED_LED_CONTROL", false);
                Crestron.sendBooleanSignal("USB_GREEN_LED_CONTROL", true);
            }
            catch
            {

            }

        }

        function setCrestronInUse() {
            try {
                Crestron.sendBooleanSignal("USB_RED_LED_CONTROL", true);
                Crestron.sendBooleanSignal("USB_GREEN_LED_CONTROL", false);
            }
            catch {

            }
        }

        function inUseText() {
            if (vm.item) {
                if (vm.roomInUse) {
                    return vm.item.InUseText;
                }
                else {
                    return vm.item.AvailableText;
                }
            }
            return "";
        }

        function getPromos() {
            var val = $stateParams.id;
            return dataservice.getItem("api/EventDisplay/GetPromosForDisplay/" + val)
                .then(function (response) {
                    vm.promos = response.data;
                }, function (error) { console.log(error); })
        }

        function getBookings() {
            if (angular.isDefined(vm.bookingPager)) {
                $interval.cancel(vm.bookingPager);
                vm.bookingPager = undefined;
            }
            var val = $stateParams.id;
            return dataservice.getItem("api/EventDisplay/GetEventsForDisplay/" + val)
                .then(function (response) {
                    vm.allBookings = response.data;
                    
                    pageBookings();
                    vm.bookingPager = $interval(pageBookings, vm.item.PageTransitionInterval * 1000)
                    checkInUse();
                }, function (error) { console.log(error); })
        }

        function pageBookings() {
            if (vm.showingPromos) {
                if (vm.onPromoImageIndex < vm.promos.length) {
                    vm.onPromoImageIndex++;
                    if (vm.onPromoImageIndex < vm.promos.length) {
                        vm.promoImageBase64Data = vm.promos[vm.onPromoImageIndex].Base64Data;
                        vm.promoImageAltText = vm.promos[vm.onPromoImageIndex].AltText;
                    }
                    else {
                        vm.showingPromos = false;
                        vm.onPromoImageIndex = 0;
                    }
                }
                else {
                    vm.showingPromos = false;
                    vm.onPromoImageIndex = 0;
                }

            }
            else {
                if (!vm.allBookings) {
                    vm.allBookings = [];
                }
                vm.totalNumberOfPages = Math.ceil(vm.allBookings.length / vm.item.NumberOfEventsPerPage);

                if (vm.firstTime) {
                    vm.firstTime = false;
                    vm.onPage = 0;
                }
                else {
                    if (vm.onPage >= (vm.totalNumberOfPages - 1)) {
                        vm.onPage = 0;
                        if (vm.promos.length > 0) {
                            vm.showingPromos = true;
                            vm.onPromoImageIndex = 0;
                            vm.promoImageBase64Data = vm.promos[vm.onPromoImageIndex].Base64Data;
                        }
                    }
                    else {
                        vm.onPage++;
                    }
                }
                var startIndex = Number(vm.onPage * vm.item.NumberOfEventsPerPage);
                var endIndex = startIndex + vm.item.NumberOfEventsPerPage;

                if (endIndex > vm.allBookings.length) {
                    vm.bookings = vm.allBookings.slice(startIndex);
                }
                else {
                    vm.bookings = vm.allBookings.slice(startIndex, endIndex);
                }

                if (vm.totalNumberOfPages > 1) {
                    $("#eventBody").hide();
                }

                $timeout(function () {
                    $("#eventBody").fadeIn('slow');
                }, 500);
            }
          
        }
        
        function getItem() {
            var val = $stateParams.id;
            return dataservice.getItem("api/EventDisplay/Display/" + val)
                .then(function (response) {
                    if (response) {
                        vm.isLicenseValid = response.data.IsLicenseValid;
                        if (vm.isLicenseValid) {
                            vm.item = response.data.ConfigDto;
                            vm.promos = response.data.PromotionalImages;
                            vm.logo = response.data.Logo;
                            vm.PictureBackgroundImage = response.data.PictureBackgroundImage;
                            vm.MainBackgroundImage = response.data.MainBackgroundImage;
                            vm.roomDescription = response.data.RoomName;
                            vm.roomCode = response.data.RoomCode;
                            $interval(getBookings, ((vm.item.DataRefreshInterval * 60) * 1000));
                            $interval(getPromos, ((30 * 60) * 1000));
                        }
                    } else {

                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function mainboxStyle() {

            var result = {};
            result.width = "100%";
            result.height = "100%";
            if (vm.MainBackgroundImage && vm.MainBackgroundImage.Base64Data) {
                result["background"] = "url(data:image/png;base64," + vm.MainBackgroundImage.Base64Data + ")";
                if (vm.item.RepeatMainBackgroundImage == 0) {
                    result["background"] += "no-repeat";
                }
            }
            else {
                if (vm.item) {
                    result["background-color"] = vm.item.PicutreBoxMainBackgroundColor;
                }
            }

            return result;
        }


        function pictureBoxStyle() {

            var result = {};
            if (vm.PictureBackgroundImage && vm.PictureBackgroundImage.Base64Data) {
                result["background"] = "url(data:image/png;base64," + vm.PictureBackgroundImage.Base64Data + ")";
                if (vm.item.RepeatPictureBackgroundImage == 0) {
                    result["background"] += "no-repeat";
                }
            }
            else {
                if (vm.item) {
                    result["background-color"] = vm.item.PicutreBoxBackgroundColor;
                }
            }


            return result;
        }

        function getPictureBoxContent(contentLocation) {
            var result = "";
         

            if (vm.roomInUse) {
                if (contentLocation === 'Top') {
                    result = vm.item.InprogressTopContent;
                }
                else if (contentLocation === 'Main') {
                    result = vm.item.InprogressMainContent;
                }
                else {
                    result = vm.item.InprogressBottomContent;
                }
            }
            else {
                if (contentLocation === 'Top') {
                    result = vm.item.AvailableTopContent;
                }
                else if (contentLocation === 'Main') {
                    result = vm.item.AvailableMainContent;
                }
                else {
                    result = vm.item.AvailableBottomContent;
                }
            }

            if (!result) {
                result = "";
            }


            result = result.replace('%DateTime%', moment(vm.currentDate).format("LL") + "<br />" + moment(vm.currentDate).format("LTS"));
            result = result.replace('%Date%', moment(vm.currentDate).format("LL"));
            result = result.replace('%Time%', moment(vm.currentDate).format("LTS"));

            result = result.replace('%RoomName%', vm.roomName());
            result = result.replace('%EventName%', vm.currentBooking.EventName);

            if (result.indexOf('%ParsedGroupName%') != -1) {

                var gn = vm.currentBooking.Group;
                var lineOne = "";
                var lineTwo = "";
                var lineTwoSize = vm.item.PictureBoxMainContentSize;
                if (gn) {
                    try {

                        var indexOfFirstSpace = gn.indexOf(' ');
                        if (indexOfFirstSpace > -1) {
                            lineTwo = gn.substr(0, indexOfFirstSpace);
                            gn = gn.substr(indexOfFirstSpace);
                        }

                        var indexOfComma = gn.indexOf(',');
                        var firstName = '';
                        var lastName = '';
                        if (indexOfComma > -1) {
                            lastName = gn.substr(0, indexOfComma);
                            firstName = gn.substr(indexOfComma + 1);
                            if (firstName.indexOf(' ') == 0) {
                                firstName = firstName.substr(1);
                            }
                            lineOne = firstName + " " + lastName;
                        }
                        else {
                            lineOne = gn;
                        }
                    }
                    catch (ex) {
                        console.log(ex)
                        lineOne = gn;
                    }


                    lineTwoSize = Math.floor(lineTwoSize * .75);

                    result = result.replace('%ParsedGroupName%', lineOne + "<br /><span style='font-size:" + lineTwoSize + "px'>" + lineTwo + "</span>");
                }
                
            }
            if (result.indexOf('%LastCommaFirst%') != -1) {
                var gn = vm.currentBooking.Group;
                if (gn) {
                    var lastName = gn.substring(0, gn.indexOf(','));
                    var firstName = gn.substring(gn.indexOf(','));
                    firstName = firstName.replace(', ', '');
                    
                    result = result.replace('%LastCommaFirst%', firstName + "<br />" + lastName);
                }

            }

            
            result = result.replace('%GroupName%', vm.currentBooking.Group);

            return $sce.trustAsHtml(result);
        }


    }
})();
